import { render, staticRenderFns } from "./FeedbackIssue.vue?vue&type=template&id=195e3716&"
import script from "./FeedbackIssue.vue?vue&type=script&lang=js&"
export * from "./FeedbackIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports